<template>
  <div class="table">
    <div class="params-form">
      <a-form-model ref="searchForm" layout="inline" :model="formState">
        <a-form-model-item>
          <a-button type="primary" @click="lookIndex">返回</a-button>
        </a-form-model-item>

        <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
        <a-form-model-item label="农产品名称" prop="produceName">
          <a-input v-model="formState.produceName"></a-input>
        </a-form-model-item>
        <a-form-model-item label="污染物名称" prop="badName">
          <a-input v-model="formState.badName"></a-input>
        </a-form-model-item>
        <a-form-model-item label="单位" prop="unit">
          <div style="display: inline-block; width: 150px">
            <a-ext-local-dic-select dic-key="Unit" v-model="formState.unit"></a-ext-local-dic-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="判定值来源" prop="valueFrom">
          <div style="display: inline-block; width: 150px">
            <a-select v-model="formState.valueFrom">
              <a-select-option value="参考">参考</a-select-option>
              <a-select-option value="自定义">自定义</a-select-option>
              <a-select-option value="引用">引用</a-select-option>
            </a-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="使用规定" prop="useFor">
          <div style="display: inline-block; width: 150px">
            <a-ext-local-dic-select dic-key="JudgeUseFor" v-model="formState.useFor"></a-ext-local-dic-select>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button @click="onResetSearch">重置</a-button><a-divider dashed="true" type="vertical" />
            <a-button type="primary" @click="onSearchPage">查询</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="table-content">
      <div>
        <div class="title" style="width: 350px; display: inline-block">
          判定标准版本
          <div v-if="selectedRowCount" style="width: 150px; display: inline-block; line-height: 20px; color: darkorange">共选择{{ selectedRowCount }}条</div>
        </div>

        <div class="btn" style="width: calc(100% - 350px); display: inline-block; text-align: right">
          <a-space>
            <a-button type="primary" @click="onQuickSetClick">快速设定</a-button>
            <a-divider dashed="true" type="vertical" />
            <a-button type="danger" @click="onBatchDelete">批量删除</a-button>
          </a-space>
        </div>
      </div>

      <a-config-provider :locale="locale">
        <a-table
          :data-source="dataSource"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          row-key="id"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          :customRow="customRow"
          @change="onPageChange"
          :scroll="{ y: 500 }"
        >
          <!--判定值-->
          <template slot="judgeValue" slot-scope="text, record">
            <div @dblclick="handleCellStatusChange(record, 'judgeValue')">
              <a-input-number v-if="record.editable.judgeValue" v-model="record.judgeValue" />
              <template v-else>
                {{ record.judgeValue || '-' }}
              </template>
            </div>
          </template>
          <!--单位-->
          <template slot="judgeUnit" slot-scope="text, record">
            <div @dblclick="handleCellStatusChange(record, 'judgeUnit')">
              <a-select v-if="record.editable.judgeUnit" v-model="record.judgeUnit">
                <a-select-option value="mg/kg">mg/kg</a-select-option>
                <a-select-option value="g/kg">g/kg</a-select-option>
              </a-select>
              <template v-else>
                {{ record.judgeUnit || '-' }}
              </template>
            </div>
          </template>
          <!--判定值来源-->
          <template slot="valueFrom" slot-scope="text, record">
            <div @dblclick="handleCellStatusChange(record, 'valueFrom')">
              <a-select v-if="record.editable.valueFrom" v-model="record.valueFrom">
                <a-select-option value="参考">参考</a-select-option>
                <a-select-option value="自定义">自定义</a-select-option>
                <a-select-option value="引用">引用</a-select-option>
              </a-select>

              <!--<a-ext-std-judge-select v-if="record.editable.valueFrom" v-model="record.valueFrom" />-->
              <template v-else>
                {{ record.valueFrom || '-' }}
              </template>
            </div>
          </template>
          <!--使用规定-->
          <template slot="useFor" slot-scope="text, record">
            <div @dblclick="handleCellStatusChange(record, 'useFor')">
              <a-input v-if="record.editable.useFor" v-model="record.useFor" />
              <template v-else>
                {{ record.useFor || '-' }}
              </template>
            </div>
          </template>
          <template slot="caozuo" slot-scope="text, record">
            <a-button type="link" @click="onQuickSetClick(record)">设定</a-button>
            <a-divider dashed="true" type="vertical" />
            <a-button type="link" @click="onDelete(record)">删除</a-button>
          </template>
        </a-table>
      </a-config-provider>
    </div>
    <add-quick-set-modal v-if="addQuickSetModalVisable" :visible.sync="addQuickSetModalVisable" :param="addQuickSetModalParam" @addModalClose="onAddQuickSetModalClose"></add-quick-set-modal>
  </div>
</template>

<script>
//分页查询接口  ①分页查询SQL
import { getStdJudgeItemPage as getPage } from '../../../api/api';
import { delStdJudgeItemSelected as delPage } from '../../../api/api';
import { addorUpdateStdJudgeItem as saveApi } from '../../../api/api';
//各个字段  ③查询条件选择组件
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect';
import AExtStdJudgeSelect from '../../../components/AntDesignExt/All/AExtStdJudgeSelect';

import AddQuickSetModal from './AddQuickSetModal';

import _ from 'lodash';
import ExportJsonExcel from 'js-export-excel';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export default {
  //各个字段  ⑤查询条件选择组件
  components: {
    AExtLocalDicSelect,
    AddQuickSetModal,
    AExtStdJudgeSelect,
  },
  props: {
    stdId: {
      type: String,
      default: '',
    },
    publishStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      locale: zhCN,

      formState: {
        //②查询条件字段名
        name: '',
      },
      params: {},
      // 表头
      columns: [
        {
          title: '农产品名称',
          dataIndex: 'produceName',
          width: '150px',
          ellipsis: true,
        },
        {
          title: '行业',
          dataIndex: 'hangye',
          width: '150px',
          ellipsis: true,
        },
        {
          title: '污染物名称',
          dataIndex: 'badName',
          width: '150px',
          ellipsis: true,
        },
        {
          title: '判定值',
          dataIndex: 'judgeValue',
          width: '150px',
          scopedSlots: { customRender: 'judgeValue' },
          ellipsis: true,
        },
        {
          title: '单位',
          dataIndex: 'judgeUnit',
          width: '150px',
          scopedSlots: { customRender: 'judgeUnit' },
          ellipsis: true,
        },
        {
          title: '判定值来源',
          dataIndex: 'valueFrom',
          width: '150px',
          scopedSlots: { customRender: 'valueFrom' },
          ellipsis: true,
        },
        {
          title: '使用规定',
          dataIndex: 'useFor',
          width: '150px',
          scopedSlots: { customRender: 'useFor' },
          ellipsis: true,
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '150px',
          scopedSlots: { customRender: 'caozuo' },
        },
      ],
      // 表格数据
      dataSource: [],
      // 选中的行
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '15', '35', '45'],
        showSizeChanger: true,
        size: 'small',
        showTotal: (total) => `共${total}条记录 `,
      },
      addQuickSetModalVisable: false,
      addQuickSetModalBackChange: null,
      addQuickSetModalParam: null,
    };
  },
  mounted() {
    this.onSearchPage();
  },
  computed: {
    selectedRowCount() {
      return this.selectedRowKeys.length;
    },
  },
  methods: {
    // 查询
    onSearchPage() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.pagination.current = 1;
      this.params = {
        pageSize: this.pagination.pageSize,
        current: this.pagination.current,
        ...this.formState,
      };
      this.getData(this.params);
    },
    //重置
    onResetSearch() {
      this.$refs.searchForm.resetFields();this.onSearchPage();
    },
    // 翻页
    onPageChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.params.pageSize = pagination.pageSize;
      this.params.current = pagination.current;
      this.getData(this.params);
    },
    // 请求接口查询数据
    getData(params) {
      this.loading = true;
      params.belongId = this.stdId;
      getPage(params)
        .then((result) => {
          this.pagination.total = result.data.data.total;
          this.pagination.current = result.data.data.current;
          this.pagination.pageSize = result.data.data.size;
          this.dataSource = result.data.data.records.map((item, index) => {
            item.index = index + 1;
            item.editable = {
              judgeValue: false,
              judgeUnit: false,
              valueFrom: false,
              useFor: false,
            };
            return item;
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 复选框变化
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      let removedItems = [];
      let addItems = [];
      this.selectedRows.forEach((oldSelectedItem) => {
        if (!selectedRowKeys.includes(oldSelectedItem.id)) {
          removedItems.push(oldSelectedItem);
        }
      });
      this.selectedRowKeys.forEach((newKey) => {
        let find = false;
        this.selectedRows.forEach((oldSelectedItem) => {
          if (oldSelectedItem.id === newKey) {
            find = true;
          }
        });
        if (!find) {
          this.dataSource.forEach((thisPageItem) => {
            if (thisPageItem.id === newKey) {
              addItems.push(thisPageItem);
            }
          });
        }
      });
      removedItems.forEach((row) => {
        this.selectedRows.remove(row);
      });
      this.selectedRows = this.selectedRows.concat(addItems);
    },
    onDelete(record) {

        let refreshData=()=>{
            this.getData(this.params);
        };
        let errAlert=()=>{
            this.$message.error(err.message);
        }

      this.$confirm({
        title: '是否删除数据?',
        content: '确认后数据将永久删除，是否确认？',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          delPage(record.id)
            .then(() => {
              refreshData()
            })
            .catch((err) => {
              errAlert()
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    // 打开设定弹窗
    onAddQuickSetModalOpen(record) {
      this.addQuickSetModalParam = record;
      this.addQuickSetModalVisable = true;
      //TODO: 无
    },
    onAddQuickSetModalClose() {
      //TODO: 无
      this.onSearchPage();
    },
    // 打开批量设定的弹窗
    onQuickSetClick(record) {
        if(record.id)
        {
            this.onAddQuickSetModalOpen({ ids: record.id });
            return
        }
      if (this.selectedRowKeys.length === 0) {
        this.$notification.warn({
          message: '警告',
          description: '未检测到选中行',
        });
        return;
      } else {
        this.onAddQuickSetModalOpen({ ids: this.selectedRowKeys.join(',') });
      }
    },
    // 批量删除
    onBatchDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选择要删除的数据');
        return;
      }
      let keys = this.selectedRowKeys;
      let funcOK = () => {
        delPage(_.join(keys, ','))
          .then(() => {
            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.getData(this.params);
          })
          .catch((err) => {
            this.$message.error(err.message);
          });
      };
      this.$confirm({
        title: '是否删除数据?',
        content: '确认后数据将永久删除，是否确认？',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          funcOK();
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
      // 导出excel
      onExportExcel() {
          if (this.selectedRowKeys.length == 0) {
              this.$message.error('请选择要导出的数据');
              return
          }
          let sheetColHeader=[];
          let sheetColFilter=[];
          this.columns.forEach(col=>{
              if(col.title !== '操作') {
                  sheetColFilter.push(col.dataIndex)
                  sheetColHeader.push(col.title)
              }
          });
          let exportRows=[];
          let i=0;
          this.selectedRows.forEach(item=>{
              i++;
              let newItem=_.cloneDeep(item);
              newItem.index=i.toString();
              exportRows.push(newItem)
          });
          let option = {};
          option.fileName = "判定标准版本";
          option.datas = [
              {
                  sheetData: exportRows,
                  sheetName: "判定标准版本",
                  sheetFilter: sheetColFilter,
                  sheetHeader: sheetColHeader,
                  columnWidths: [],
              },
          ];

          var toExcel = new ExportJsonExcel(option); //new
          toExcel.saveExcel();
      },
    lookIndex(record) {
      this.$emit('fanhui', null);
    },
    // 自定义行点击事件
    customRow(record) {
      return {
        on: {
          click: (event) => {
            // 过滤掉input与select的单击效果
            if (event.target.tagName !== 'INPUT' && !event.target.classList.contains('ant-select-selection__rendered') && !event.target.classList.contains('ant-select-selection-selected-value')) {
              this.dataSource.forEach((row) => {
                ['judgeValue', 'judgeUnit', 'valueFrom', 'useFor'].forEach((column) => {
                  if (row.editable[column] === true) {
                    if (column !== 'valueFrom') {
                      row.valueFrom = '自定义';
                    }
                    saveApi(row)
                      .then((res) => {
                        row.editable[column] = false;
                        this.$notification.success({
                          message: '成功',
                          description: '保存成功',
                        });
                      })
                      .catch((e) => {
                        console.error(e);
                        this.$notification.error({
                          message: '失败',
                          description: '保存失败',
                        });
                      });
                  }
                });
              });
            }
          },
          dbclick: () => {},
        },
      };
    },
    // 双击修改单元格的状态
    handleCellStatusChange(record, key) {
      // 判定值\单位\判定值来源\使用规定
      this.dataSource.forEach((row) => {
        ['judgeValue', 'judgeUnit', 'valueFrom', 'useFor'].forEach((column) => {
          row.editable[column] = false;
        });
      });
      record.editable[key] = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  .params-form {
    padding-top: 16px;
    padding-left: 20px;
    margin: 16px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    border-radius: 8px;
    background-color: rgb(255, 255, 255);
    box-shadow: #1b2f7017 0px 2px 4px 2px;
  }
  .table-content {
    margin: 16px;
    padding: 20px 24px;
    box-shadow: #1b2f7017 0px 2px 4px 2px;
    background-color: rgb(255, 255, 255);
    border-radius: 8px;
    overflow-y: hidden;
    .title {
      padding-left: 12px;
      font-size: 16px;
      font-weight: 500;
      line-height: 1;
      color: rgba(0, 0, 0, 0.85);
      position: relative;
      margin-bottom: 16px;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
    }
    .title::before {
      content: '';
      position: absolute;
      height: 16px;
      top: calc(50% - 8px);
      left: 0px;
      width: 3px;
      background-color: rgb(36, 113, 210);
    }

    .btn {
      padding-bottom: 15px;
      display: flex;
      justify-content: end;
    }

    /deep/ .ant-table-wrapper {
      .ant-table {
        border-top: 1px solid rgba(15, 41, 61, 0.45);
        border-bottom: 1px solid rgba(15, 41, 61, 0.45);
        border-image: initial;
        border-left: none;
        border-right: none;
      }
      .ant-table-thead {
        background: #fafafa;
      }
      .ant-table-thead > tr > th {
        font-weight: 500;
        line-height: 1;
        color: rgba(21, 40, 77, 0.65);
        background-color: rgb(245, 250, 255);
      }
    }
  }
}
/deep/ .ant-input-number,.ant-select{
  width: 100%;
}
</style>
